import React, { useEffect, useState } from "react";

interface BlogPost {
     id: number;
     title: string;
     date: string;
     excerpt: string;
     link: string;
}

const blogPosts: BlogPost[] = [
     {
          id: 1,
          title: "How to Improve SEO for Your Website",
          date: "November 23, 2024",
          excerpt:
               "Learn essential tips to boost your website's search engine ranking with proper SEO strategies.",
          link: "/blog/seo-tips",
     },
     {
          id: 2,
          title: "React TypeScript: A Beginner's Guide",
          date: "November 20, 2024",
          excerpt:
               "Discover how to get started with React and TypeScript to build scalable and maintainable applications.",
          link: "/blog/react-typescript",
     },
     {
          id: 3,
          title: "Mastering SCSS for Modern Web Development",
          date: "November 18, 2024",
          excerpt:
               "Understand how SCSS simplifies styling for modern web applications with advanced features.",
          link: "/blog/mastering-scss",
     },
];



const BlogPage = () => {

     const [data, setData] = useState<any>([]);

     useEffect(() => {

          const API_KEY = '5KTn7yCjjMbYwfDkGR8C3DUi05ZfnTGq';
          const BASE_URL = 'https://api.baserow.io/api/database/rows/table/509208/';

          async function fetchData() {
               try {
                    const response = await fetch(BASE_URL, {
                         method: 'GET',
                         headers: {
                              'Authorization': `Token ${API_KEY}`,
                              'Content-Type': 'application/json',
                              
                              
                         },
                    });

                    const data = await response.json();


                    setData(data)

               } catch (error) {
                    console.error('Error fetching data:', error);
               }
          }

          fetchData();
     }, []);


     return (
          <div className="__blogIN">
               <div className="__blogIN-head">
                    <h2 className="title">Fresh Stories and Updates</h2>
                    <p className="subtitle">
                         Discover what's been happening behind the scenes — new ideas, creative projects, and inspiring milestones. Stay connected and explore our latest chapters, crafted just for you.
                    </p>
               </div>

               <div className="__container">
                    <div className="row">
                         {data?.results?.map((item: any, index: any) => (
                              <div className="col-md-4" key={index}>
                                   <div className="__in__center">
                                        <iframe
                                        src={`https://www.linkedin.com/embed/feed/update/urn:li:share:${item?.field_4030745}?collapsed=1`}
                                        height="500"
                                        width="100%"
                                        title="Embedded post"
                                   ></iframe>
                                   </div>
                              </div>
                         ))}
                    </div>
               </div>

               <div className="blogList d-none">
                    {blogPosts.map((post) => (
                         <div key={post.id} className="blogCard">
                              <h2 className="blogTitle">{post.title}</h2>
                              <p className="blogDate">{post.date}</p>
                              <p className="blogExcerpt">{post.excerpt}</p>
                              <a href={post.link} className="readMore">
                                   Read More →
                              </a>
                         </div>
                    ))}
               </div>
          </div>
     );
};

export default BlogPage;
